module.exports = __webpack_public_path__ + "images/shop/favicon-kfzteile-com/safari-pinned-tab.svg";